/**
 * Generate a unique correlation ID for API requests
 * Format: admin-{timestamp}-{random}
 */
export const generateCorrelationId = (): string => {
  const timestamp = Date.now()
  const random = Math.random().toString(36).substring(2, 11)
  return `admin-${timestamp}-${random}`
}
